import {DescriptionNode} from './DescriptionNode';
import {PortDefinitionResponse} from './PortDefinitionResponse';
import {TickDefinitionResponse} from './TickDefinitionResponse';

export class BlockDefinitionResponse
{
    public readonly clazz:string;
    public readonly type:string;
    public readonly name:string;
    public readonly section:string;
    public readonly description:string;
    public readonly ticks:TickDefinitionResponse[];
    public readonly warn:string[];
    public readonly inputs:PortDefinitionResponse[];
    public readonly outputs:PortDefinitionResponse[];
    public readonly properties:DescriptionNode[];
    public readonly categories:DescriptionNode[];
    public readonly keywords:DescriptionNode[];
    public readonly typeDescriptor:string;

    constructor(json:any)
    {
        this.clazz = json['clazz'];
        this.type = json['type'];
        this.name = json['name'];
        this.section = json['section'];
        this.description = json['description'];
        this.ticks = [];
        for( let i = 0, length = (json['ticks'] || []).length; i < length; i++ )
        {
            this.ticks.push(new TickDefinitionResponse(json['ticks'][i]));
        }
        this.warn = [];
        for( let i = 0, length = (json['warn'] || []).length; i < length; i++ )
        {
            this.warn.push(json['warn'][i]);
        }
        this.inputs = [];
        for( let i = 0, length = (json['inputs'] || []).length; i < length; i++ )
        {
            this.inputs.push(new PortDefinitionResponse(json['inputs'][i]));
        }
        this.outputs = [];
        for( let i = 0, length = (json['outputs'] || []).length; i < length; i++ )
        {
            this.outputs.push(new PortDefinitionResponse(json['outputs'][i]));
        }
        this.properties = [];
        for( let i = 0, length = (json['properties'] || []).length; i < length; i++ )
        {
            this.properties.push(new DescriptionNode(json['properties'][i]));
        }
        this.categories = [];
        for( let i = 0, length = (json['categories'] || []).length; i < length; i++ )
        {
            this.categories.push(new DescriptionNode(json['categories'][i]));
        }
        this.keywords = [];
        for( let i = 0, length = (json['keywords'] || []).length; i < length; i++ )
        {
            this.keywords.push(new DescriptionNode(json['keywords'][i]));
        }
        this.typeDescriptor = json['typeDescriptor'];
    }
}
